import React, { Component } from 'react';
import Result from './Result';

import '../App.css';

class Results extends Component {
    state = {
        correctAnswers: 0,
    }
    
    componentDidMount(){
        const {toggleLoading} = this.props;
        toggleLoading();
    }

    componentWillReceiveProps(nextProps) {
        this.onPropsChange(nextProps);
    }

    onPropsChange(props){
        const {results} = props.state;
        
        let tempNum = 0
        results.forEach((result)=>{
            if(result.bool===1){
                tempNum+=1;
            }
        })
        this.setState({
            correctAnswers: tempNum
        })
    }

    createMessage(){
        const {amount} = this.props.state
        let message = '';
        if(this.state.correctAnswers/amount===1){
            message = 'Congratulations, you got everything right'
        } else if (this.state.correctAnswers/amount>0.7){
            message = `Great Performance, you got 
                ${this.state.correctAnswers} right out of ${amount}`
        } else if (this.state.correctAnswers/amount>0.4){
            message =  `Good Performance, you got 
            ${this.state.correctAnswers} right out of ${amount}`
        } else {
            message = `Horrible Performance, you got 
            ${this.state.correctAnswers} right out of ${amount}`
        }
        return message
    }

    render() {
        const{loading, results} = this.props.state;
        const message = this.createMessage();
        return(
            <div className = "Results answer-container bg-white p-4 mt-5 mb-5 rounded">
                {!loading &&
                    <div>
                        <h1 className = "h3 text-muted text-center quiz-heading">Results of your Quiz</h1>   
                        <p className = "text-center p-5 mb-5 bg-dark text-white ">{message}</p>
                        <div className = "text-muted">
                                Attempted Questions
                        </div>
                        {results.map((result, index)=>(
                            <Result 
                                result = {result} 
                                key = {index} 
                                resultID = {result.id}
                            />
                            ))
                        }
                        <button className = "btn btn-warning d-block text-white" onClick = {this.props.resetState}>Play Again</button>         
                    </div>
                }
            </div>
        )
    }
}

export default Results;